import React from "react"
import Relay from "react-relay"
import classnames from "classnames"
import InlineSearchResult from "./InlineSearchResult"
import Icon from "../elements/Icon"
import LoadMoreLink from "../elements/LoadMoreLink"
import { FormattedMessage, injectIntl } from "react-intl"
import searchMessages from "../../messages/search"
import sharedMessages, { messages } from "../../messages/index"
import { getStyles, getStyleTag } from '../../styles/dynamicStyles'

class InlineSearch extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      search: "",
      loading: false
    }
  }

  render() {
    const intl = this.props.intl
    const results = this.props.viewer.results.edges
    const hasNextPage = this.props.viewer.results.pageInfo.hasNextPage

    return (
      <div
        style={getStyles('c-inline-search')}
        className={classnames("c-inline-search", {
          loading: this.state.loading
        })}
      >
        {getStyleTag(['c-inline-search', 'input-group-button__button'])}
        <div className="single-column single-column--skinny">
          <div className="c-search" role="search">
            <form className="c-search__form input-group" action="">
              <label className="show-for-sr" htmlFor="site-search">
                <FormattedMessage {...searchMessages.existingImages} />
              </label>
              <input
                className="c-search__input input-group-field"
                type="search"
                placeholder={intl.formatMessage(
                  searchMessages.existingResources
                )}
                value={this.state.search}
                onChange={e => this._searchText(e)}
                onKeyDown={e => {
                  if (e.which === 13) this._searchResources(e)
                }}
              />
              <div className="c-search__button-holder input-group-button">
                <button
                  type="button"
                  className="button c-search__button"
                  onClick={this._searchResources}
                  style={getStyles('input-group-button__button')}
                  title="Search for an existing image from the site"
                >
                  <Icon icon="search" />
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="single-column single-column--wide">
          <div className="thumbnail-grid thumbnail-grid--wide-column">
            {results.map(edge => {
              return (
              <InlineSearchResult
                key={edge.node.id || edge.node.__dataID__}
                resource={edge.node}
                handleClick={this._clickResourse}
              />
            )})}
            {hasNextPage && (
              <LoadMoreLink onClick={this._handleLoadMore}>
                <FormattedMessage {...sharedMessages.loadMoreItems} />
              </LoadMoreLink>
            )}
          </div>
        </div>
      </div>
    )
  }

  _searchText = e => {
    this.setState({ search: e.target.value })
  }

  _searchResources = e => {
    e.preventDefault()

    this.props.relay.setVariables(
      {
        search: this.state.search
      },
      readyState => {
        const loading = !readyState.done

        if (loading != this.state.loading) {
          this.setState({
            loading: loading
          })
        }
      }
    )
  }

  _clickResourse = (resource, e) => {
    if (this.props.handleResourceClick) {
      this.props.handleResourceClick(resource, e)
    }
  }

  _handleLoadMore = e => {
    e.preventDefault()

    this.props.relay.setVariables(
      {
        pageSize: this.props.relay.variables.pageSize + 12
      },
      readyState => {
        const loading = !readyState.done

        if (loading != this.state.loading) {
          this.setState({
            loading: loading
          })
        }
      }
    )
  }
}

export default Relay.createContainer(injectIntl(InlineSearch), {
  initialVariables: {
    search: null,
    pageSize: 12,
    mediaType: "image"
  },

  prepareVariables: vars => {
    let type = vars.mediaType

    if (type === "image") {
      type = "NOT (audio OR video OR cms_page)"
    } else {
      type = type + " NOT cms_page"
    }

    return {
      ...vars,
      type: type
    }
  },

  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        results: resources(q: $search first: $pageSize with_files: true access_rights: "published", type: $type) {
          edges {
            node {
              ${InlineSearchResult.getFragment("resource")}
            }
          }
          pageInfo {
            hasNextPage
          }
        }
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/InlineSearch.js